/* JLA-004: cart drawer free-shipping A/B (Shoplift).
   A = top yellow progress bar + footer subtotal (legacy layout).
   B = footer progress bar + scroll subtotal + mobile header hide-on-scroll.
   B's footer bar sits outside <form>, so fill%/label are recomputed from
   globalVariables.cart after component-cart-form.js _updateCart swaps form HTML. */
(function () {
  // Real Variant ID from the JLA-004 Shoplift test. Control = layout A (false).
  var hypothesisId = '019f811a-d236-79fc-a942-1f5403b46e7f';
  var STORAGE_KEY = 'joola:shipping-bar:layout:' + hypothesisId;

  var lastFillPercent = 0;
  var showVariantB = null;
  var assignmentConfirmed = false;
  var resolvingPromise = null;
  var retryTimer = null;
  var attemptCount = 0;
  var syncScheduled = false;
  var headerScrollInited = false;

  var MAX_ATTEMPTS = 8;
  var RETRY_BASE_MS = 500;
  var REQUEST_TIMEOUT_MS = 3000;
  // Hard cap so a missing/broken Shoplift script never leaves .shoplift-hide on forever.
  var FAILSAFE_MS = 10000;

  var reducedMotion = Boolean(
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  function drawer() {
    return document.querySelector('cart-form#ajax-cart.cart-drawer');
  }

  function readStickyLayout() {
    try {
      var v = window.sessionStorage.getItem(STORAGE_KEY);
      if (v === 'b') return true;
      if (v === 'a') return false;
    } catch (e) { /* private mode */ }
    return null;
  }

  function writeStickyLayout(isB) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, isB ? 'b' : 'a');
    } catch (e) { /* private mode */ }
  }

  // Preview: ?slVariant=<id> → B, ?slControl=<id> → A.
  // Sticky keeps the choice across PDP navigations (Shopify drops query params).
  function forcedByUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('slVariant') === hypothesisId) return true;
      if (params.get('slControl') === hypothesisId) return false;
    } catch (e) { /* ignore */ }
    return null;
  }

  function setLayoutVisibility(isB) {
    var root = drawer();
    if (!root) return;

    root.classList.toggle('cart-drawer--variant-b', isB);
    root.classList.toggle('cart-drawer--variant-a', !isB);
    root.classList.remove('shoplift-hide');

    root.querySelectorAll('[data-layout-a]').forEach(function (el) {
      if (isB) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      }
    });
    root.querySelectorAll('[data-layout-b]').forEach(function (el) {
      if (isB) {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }
    });

    if (isB && !headerScrollInited) {
      initDrawerHeaderScroll();
      headerScrollInited = true;
    }
  }

  function confirmAssignment(isB) {
    showVariantB = Boolean(isB);
    assignmentConfirmed = true;
    writeStickyLayout(showVariantB);
    if (retryTimer) {
      clearTimeout(retryTimer);
      retryTimer = null;
    }
    setLayoutVisibility(showVariantB);
    return showVariantB;
  }

  function failSafeToControlOrSticky() {
    var sticky = readStickyLayout();
    confirmAssignment(sticky === null ? false : sticky);
  }

  function scheduleRetry() {
    if (assignmentConfirmed || retryTimer) return;
    if (attemptCount >= MAX_ATTEMPTS) {
      // Exhausted retries → sticky if any, else Control (A). Same fail-safe as JLA-005.
      failSafeToControlOrSticky();
      return;
    }
    var delay = Math.min(RETRY_BASE_MS * Math.pow(2, Math.max(0, attemptCount - 1)), 8000);
    retryTimer = setTimeout(function () {
      retryTimer = null;
      resolveAssignment();
    }, delay);
  }

  function resolveAssignment() {
    if (assignmentConfirmed) return Promise.resolve(showVariantB);
    if (resolvingPromise) return resolvingPromise;

    var forced = forcedByUrl();
    if (forced !== null) return Promise.resolve(confirmAssignment(forced));

    var sticky = readStickyLayout();
    if (sticky !== null) return Promise.resolve(confirmAssignment(sticky));

    if (!window.shoplift || typeof window.shoplift.isHypothesisActive !== 'function') {
      attemptCount += 1;
      scheduleRetry();
      return Promise.resolve(null);
    }

    attemptCount += 1;

    var request = window.shoplift.isHypothesisActive(hypothesisId).then(
      function (value) {
        return { ok: true, value: Boolean(value) };
      },
      function () {
        return { ok: false, value: null };
      }
    );

    var timeout = new Promise(function (resolve) {
      setTimeout(function () {
        resolve({ ok: false, value: null });
      }, REQUEST_TIMEOUT_MS);
    });

    // Only confirm on a genuine Shoplift answer — timeouts/errors leave UI pending and retry.
    resolvingPromise = Promise.race([request, timeout]).then(function (result) {
      resolvingPromise = null;
      if (result && result.ok) return confirmAssignment(result.value);
      scheduleRetry();
      return showVariantB;
    });

    return resolvingPromise;
  }

  function applyLayout() {
    if (!drawer()) return;
    if (assignmentConfirmed && showVariantB !== null) {
      setLayoutVisibility(showVariantB);
      return;
    }
    resolveAssignment();
  }

  function readFillPercent(el) {
    var match = /([\d.]+)%/.exec(el.style.width || '');
    return match ? parseFloat(match[1]) : 0;
  }

  function animateFill(fillEl) {
    var targetPercent = readFillPercent(fillEl);
    if (targetPercent === lastFillPercent) return;
    if (reducedMotion) {
      lastFillPercent = targetPercent;
      return;
    }
    fillEl.style.transition = 'none';
    fillEl.style.width = lastFillPercent + '%';
    void fillEl.offsetWidth;
    fillEl.style.transition = '';
    requestAnimationFrame(function () {
      fillEl.style.width = targetPercent + '%';
    });
    lastFillPercent = targetPercent;
  }

  function updateShippingProgress() {
    if (!showVariantB) return;
    var progressEl = document.querySelector('.cart-drawer-footer [data-shipping-progress]');
    if (!progressEl || !window.globalVariables || !window.globalVariables.cart) return;

    var threshold = parseFloat(progressEl.getAttribute('data-threshold')) || 0;
    var eligibleCents = Math.round(threshold * 100);
    if (eligibleCents <= 0) return;

    var cartTotal = window.globalVariables.cart.total_price;
    var isUnlocked = cartTotal >= eligibleCents;
    var fillPercent = isUnlocked ? 100 : Math.round((cartTotal / eligibleCents) * 100);

    progressEl.classList.toggle('is-unlocked', isUnlocked);

    var fillEl = progressEl.querySelector('.shipping-progress__fill');
    if (fillEl) {
      fillEl.style.width = fillPercent + '%';
      fillEl.setAttribute('aria-valuenow', String(fillPercent));
    }

    var labelEl = progressEl.querySelector('.shipping-progress__label');
    if (!labelEl) return;
    if (isUnlocked) {
      labelEl.textContent = progressEl.getAttribute('data-unlocked-text') || '';
      return;
    }
    var remainingCents = eligibleCents - cartTotal;
    var formattedRemaining =
      window.Utility && typeof window.Utility.formatMoney === 'function'
        ? window.Utility.formatMoney(remainingCents, window.globalVariables.money_format)
        : '$' + (remainingCents / 100).toFixed(2);
    var template = progressEl.getAttribute('data-left-template') || '';
    labelEl.textContent = template.replace('${leftAmount}', formattedRemaining);
  }

  function syncAfterCartMutation() {
    applyLayout();
    updateShippingProgress();
    var fillEl = document.querySelector('.cart-drawer-footer .shipping-progress__fill');
    if (fillEl && showVariantB) animateFill(fillEl);
    else if (!showVariantB) lastFillPercent = 0;
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(function () {
      syncScheduled = false;
      syncAfterCartMutation();
    });
  }

  function initDrawerHeaderScroll() {
    var drawerEl = drawer();
    var header = drawerEl && drawerEl.querySelector('[data-cart-drawer-header]');
    var scrollEl = drawerEl && drawerEl.querySelector('.cart-form-container');
    if (!drawerEl || !header || !scrollEl) return;

    var mobileQuery = window.matchMedia && window.matchMedia('(max-width: 767px)');

    function syncHeaderHeight() {
      drawerEl.style.setProperty('--drawer-header-height', header.offsetHeight + 'px');
    }
    syncHeaderHeight();

    var lastScrollTop = 0;
    var ticking = false;
    var idleTimer = null;

    function showHeader() {
      header.classList.remove('drawer-header-hidden');
      header.removeAttribute('aria-hidden');
    }
    function hideHeader() {
      if (!drawerEl.classList.contains('cart-drawer--variant-b')) {
        showHeader();
        return;
      }
      header.classList.add('drawer-header-hidden');
      header.setAttribute('aria-hidden', 'true');
    }

    function onScroll() {
      ticking = false;
      if (!drawerEl.classList.contains('cart-drawer--variant-b') || !mobileQuery || !mobileQuery.matches) {
        showHeader();
        return;
      }
      var top = scrollEl.scrollTop;
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(showHeader, 800);
      if (top <= 0) showHeader();
      else if (top > lastScrollTop) hideHeader();
      else if (top < lastScrollTop) showHeader();
      lastScrollTop = top;
    }

    scrollEl.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        syncHeaderHeight();
        if (!mobileQuery || !mobileQuery.matches) showHeader();
      },
      { passive: true }
    );

    new MutationObserver(function () {
      if (drawerEl.classList.contains('opened-drawer')) {
        syncHeaderHeight();
        showHeader();
        lastScrollTop = 0;
        if (idleTimer) clearTimeout(idleTimer);
      }
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    var fillEl = document.querySelector('.cart-drawer-footer .shipping-progress__fill');
    lastFillPercent = fillEl ? readFillPercent(fillEl) : 0;
    applyLayout();

    setTimeout(function () {
      if (!assignmentConfirmed) failSafeToControlOrSticky();
    }, FAILSAFE_MS);

    var containers = document.querySelectorAll(
      '.cart-drawer .cart-form-container, .cart-page .cart-form-container'
    );
    if (containers.length) {
      var observer = new MutationObserver(scheduleSync);
      containers.forEach(function (container) {
        observer.observe(container, { childList: true, subtree: true });
      });
    }

    document.addEventListener('cart:updated', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
